module.exports = __webpack_public_path__ + "img/code.f2141e31.png";